import * as React from 'react';

import Login from 'modules/login';
import { translate } from 'components/translate-hoc';
import { ILandingPageTypes } from './landing-page.types';
import { navigateToLink } from 'utils/scroll-link';

import AnalyticsService from 'modules/analytics-provider/analytics-provider.service';

import {
    LANDING_PAGE_TEXTS,
    ANALYTICS_LANDING_FLOW_STEP,
    ANALYTICS_LANDING_FLOW_ACTIONS
} from './landing-page.constants';
import { CATEGORY } from 'modules/analytics-provider/analytics-provider.constants';

import { STEPS_DESCRIPTION_ANCHOR_ID } from '../steps-description/steps-description.component';

import './landing-page.styles.less';
import { getModeClass } from 'utils/css';

const STEPS_DESCRIPTION_ANCHOR = `#${STEPS_DESCRIPTION_ANCHOR_ID}`;

export class LandingPage extends React.Component<ILandingPageTypes> {
    private isAnalyticsFlowRequestSend = false;

    public handleAnchorScroll = (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        event.stopPropagation();

        AnalyticsService.sendFlowEvent({
            ...ANALYTICS_LANDING_FLOW_STEP,
            action: ANALYTICS_LANDING_FLOW_ACTIONS.DISCOVER,
            category: CATEGORY.ACTION
        });

        navigateToLink(STEPS_DESCRIPTION_ANCHOR);
        return null;
    };

    public sendAnalyticsFlowStats = () => {
        if (this.isAnalyticsFlowRequestSend) {
            return;
        }

        AnalyticsService.sendFlowEvent({
            ...ANALYTICS_LANDING_FLOW_STEP,
            action: ANALYTICS_LANDING_FLOW_ACTIONS.LANDING_PAGE,
            category: CATEGORY.DISPLAY
        });

        this.isAnalyticsFlowRequestSend = true;
    };

    public render(): JSX.Element {
        const { dangerouslyTranslateWithHTML: translateKey, shouldInheritStyles } = this.props;
        const basePageStyleClass = getModeClass('sitegen-fr-landing-page', shouldInheritStyles);
        this.sendAnalyticsFlowStats();

        return (
            <div className={basePageStyleClass}>
                <div className={`${basePageStyleClass}__title`}>{translateKey(LANDING_PAGE_TEXTS.TITLE)}</div>
                <div className={`${basePageStyleClass}__content-wide`}>
                    <div className={`${basePageStyleClass}__column`}>
                        <div className={`${basePageStyleClass}__subtitle`}>
                            {translateKey(LANDING_PAGE_TEXTS.SUBTITLE)}
                        </div>
                        <div className={`${basePageStyleClass}__description`}>
                            {translateKey(LANDING_PAGE_TEXTS.DESCRIPTION)}
                        </div>
                        <a href={STEPS_DESCRIPTION_ANCHOR}
                            onClick={this.handleAnchorScroll}
                            className={`${basePageStyleClass}__scroll-link`}>
                            {translateKey(LANDING_PAGE_TEXTS.SCROLL_LINK)}
                        </a>
                    </div>
                    <div className="sitegen-fr-landing-page__column">
                        <Login alwaysConfirmAccount={false}/>
                    </div>
                </div>
            </div>
        );
    }
}

export const LandingPageWithTranslations = translate()(LandingPage);
